<template>
  <!-- 移动端 -->
  <!-- <div class="mobile—login" v-if="isMobile">
    <div class="header">
      <img src="../assets/imgs/logo.png" style="height: 100px" alt="" />
    </div>
    <div class="content">
      <div class="input-box">
        账号
        <van-field v-model="form.username" placeholder="请输入账号" />
      </div>
      <div class="input-box">
        密码
        <van-field
          v-model="form.password"
          type="password"
          placeholder="请输入密码"
        />
      </div>
    </div>
    <div class="input-box">
      <div class="set" @click="sign()">注册账号</div>
      <div class="reset" @click="reset()">忘记密码</div>
    </div>
    <div class="footer">
      <div class="login gradient-background" @click="login">
        确定<i v-if="loading" class="el-icon-loading"></i>
      </div>
    </div>
  </div> -->
  <div v-if="isMobile">
    <OfficialLogin />
    <div class="login-build-version">FE {{ buildVersion }}</div>
  </div>
  <!-- PC端 -->
  <div class="pc-login" v-else>
    <div class="pc-login_container">
      <!-- 培训列表 -->
      <div class="title">广东省职业健康协会培训平台</div>
      <!-- <div class="train-list">
        <div class="training-item">
          <h3>
            <i class="fas fa-laptop"></i> 职业健康检查机构医疗卫生技术人员（职业健康检查知识培训）
          </h3>
        </div>
        <div class="training-item">
          <h3>
            <i class="fas fa-chalkboard-teacher"></i>
            放射工作人员放射防护培训
          </h3>
        </div>
        <div class="training-item">
          <h3><i class="fas fa-radiation"></i> 职业病诊断医师继续教育培训</h3>
        </div>
        <div class="training-item">
          <h3><i class="fas fa-user-md"></i> 职业卫生技术服务机构专业技术人员培训</h3>
        </div>
        <div class="training-item">
          <h3>
            <i class="fas fa-flask"></i>
            用人单位职业健康培训
          </h3>
        </div>
      </div> -->
      <!-- 登录框 -->
      <div class="login-box">
        <el-card class="box-card" v-if="loginType == '1'">
          <div class="header">
            <img src="../assets/imgs/logo.png" alt="" />
            <!-- <div>广东省职业健康协会培训平台</div> -->
          </div>
          <div class="content">
            <el-form
              ref="loginForm"
              :model="form"
              :rules="rules"
              label-width="100px"
              label-position="top"
            >
              <el-form-item label="账号" prop="username">
                <el-input
                  v-model="form.username"
                  placeholder="请输入账号"
                ></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="username">
                <el-input
                  v-model="form.password"
                  type="password"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="input-box">
              <!-- <div class="set" @click="sign()">注册报名</div>
            <div class="reset" @click="reset()">忘记密码</div> -->
              <div class="sms-login" @click="assignLoginType('2')">
                短信验证码登录
              </div>
              <!-- <div class="sms-login" @click="assignLoginType('2')">
                注册报名
              </div> -->
            </div>
            <!-- <div class="reset" @click="reset()">忘记密码</div> -->
          </div>
          <div class="footer">
            <div class="login gradient-background" @click="checkLogin">
              登录<el-icon v-if="loading"><Loading /></el-icon>
            </div>
          </div>
        </el-card>
        <PcsmsLogin
          v-if="loginType == '2'"
          @assignLoginType="assignLoginType"
        />
      </div>
    </div>
    <div class="content-footer">
      <div class="login-build-version">FE {{ buildVersion }}</div>
      <p>粤ICP备13059083号</p>
      <p>广州梦山科技有限公司提供服务支持</p>
    </div>
    <!-- 弹框 -->
    <el-dialog v-model="dialogInfo.show" width="500px" :show-close="false">
      <!-- 忘记密码修改密码 -->
      <div class="reset-dialog" v-if="dialogInfo.status == 1">
        <div class="dialag-title">请填写您的修改密码信息</div>
        <el-form
          ref="loginForm"
          :model="form"
          :rules="rules"
          label-width="100px"
          label-position="top"
        >
          <el-form-item label="手机号码" prop="username">
            <el-input
              v-model="form.mobile"
              placeholder="请输入手机号码"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证" prop="username">
            <el-input
              v-model="form.idCard"
              type="password"
              placeholder="请输入身份证"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="confirm gradient-background" @click="btns(true)">确定</div>
      </div>
      <!-- 设置密码成功 -->
      <div class="reset-result" v-if="dialogInfo.status == 2">
        <div class="result gradient-background">
          <el-icon><Check /></el-icon>
        </div>
        <p>修改密码成功</p>
        <div
          class="confirm gradient-background"
          @click="dialogInfo.show = false"
        >
          立即登录
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OfficialLogin from "../components/OfficialLogin.vue";
import PcsmsLogin from "../components/PcsmsLogin.vue";
import { Loading, Check } from "@element-plus/icons-vue";
import { resolveBuildVersion } from "../utils/buildVersion.cjs";
export default {
  name: "login",
  components: { OfficialLogin, Loading, Check, PcsmsLogin },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      isMobile: false,
      loading: false,
      dialogInfo: {
        show: false, // 显示弹框
        status: "", //  0提示修改初始密码，1设置新密码，2忘记密码修改密码，3修改密码成功
        idCard: "",
        mobile: "",
      },
      buildVersion: resolveBuildVersion({
        VUE_APP_BUILD_VERSION: process.env.VUE_APP_BUILD_VERSION,
        VUE_APP_VERSION: process.env.VUE_APP_VERSION,
        npm_package_version: process.env.npm_package_version,
      }),
      rules: {
        username: [{ required: true, message: "请输入帐号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        idCard: [{ required: true, message: "请输入身份证", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
        ],
      },
      // 1 账号密码登录 2 短信验证码登录
      loginType: "1",
    };
  },
  created() {
    const userInfo = sessionStorage.getItem("userInfo");
    this.isMobile = this._isMobile();
    if (userInfo) {
      this.$router.replace({
        path: this._isMobile() ? "/mobileHome" : "/home",
      });
    }
  },
  methods: {
    sign() {
      //this.$router.replace({ path: "/register" });
      // this.$router.replace({ path: "/signUp" });
    },
    reset() {
      // if (this._isMobile()) {
      //   this.$router.replace({ path: "/operation" });
      // } else {
      //   this.dialogInfo.show = true;
      //   this.dialogInfo.status = 1;
      // }
    },
    checkLogin() {
      if (this.loading) return;
      if (this._isMobile()) {
        this.login();
      } else {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.login();
          } else {
            return false;
          }
        });
      }
    },
    login() {
      this.loading = true;
      this.$https
        .post("/api/login", {
          mobile: this.form.username,
          password: this.form.password,
        })
        .then((res) => {
          this.loading = false;
          console.log(res);
          if (res.success) {
            const data = res.data;
            console.log(this._isMobile() ? "/mobileHome" : "/home");
            sessionStorage.setItem("userInfo", JSON.stringify(data));
            if (this._isMobile()) {
              this.$router.replace({
                path: "/mobileHome",
              });
              console.log("/mobileHome");
            } else {
              this.$router.replace({
                path: "/home",
              });

              console.log("/home");
            }
          } else {
            this.loading = false;
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.message || "账号或者密码错误");
        });
    },
    assignLoginType(type, data) {
      this.loginType = type;
      if (data.phone) {
        this.form.username = data.phone;
      }
    },
  },
};
</script>
<style lang="less" scope>
// 移动端
.mobile—login {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 50px 40px;
  font-size: 20px;
  .header {
    text-align: center;
    margin-bottom: 100px;
  }
  .van-cell {
    line-height: 50px;
    padding: 0 10px;
    border: 1px solid #b0b9ca;
    border-radius: 5px;
    font-size: 16px;
  }
  .set {
    display: inline-block;
    top: 55px !important;
    line-height: 20px !important;
    cursor: pointer;
    right: 2px;
    color: #b0b9ca;
    font-size: 12px;
    border-bottom: 1px solid #b0b9ca;
  }
  .reset {
    display: inline-block;
    position: absolute;
    top: 0;
    line-height: 20px !important;
    cursor: pointer;
    right: 2px;
    color: #b0b9ca;
    font-size: 12px;
    border-bottom: 1px solid #b0b9ca;
  }
  .footer {
    margin-top: 50px;
    .login {
      line-height: 50px;
    }
  }
  .input-box {
    font-size: 20px;
    margin-top: 2%;
    position: relative;
    line-height: 40px;
    color: #677897;
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
  }
}

.pc-login {
  position: relative;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 24px 24px 18px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
  -o-background-size: 100% 100%;
  background-image: url(../assets/imgs/background.png);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  // min-width: 1440px;
  .pc-login_container {
    position: relative;
    width: 100%;
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    .title {
      color: #fff;
      font-size: 70px;
      text-align: center;
      margin-bottom: 60px;
    }
    .train-list {
      display: inline-block;
      width: 500px;
      padding: 20px 0;
      border-radius: 15px;
      position: relative;
      top: -70px;
      margin-right: 10%;
      .training-item {
        margin-bottom: 20px;
        border-radius: 10px;
        /* 毛玻璃效果 */
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.3);
        padding: 18px 20px;
        transition: all 0.3s ease;
        cursor: pointer;
      }
      .training-item h3 {
        font-size: 18px;
        display: flex;
        align-items: start;
        color: #fff;
        text-align: left;
        line-height: 1.5;
      }
      .training-item h3 i {
        margin-right: 10px;
        color: #ffd700;
      }
      .training-item p {
        font-size: 14px;
        opacity: 0.9;
        margin-left: 28px;
      }
    }
    .login-box {
      display: inline-block;
      width: 400px;
      height: 50%;
      .box-card {
        padding: 20px;
        background: #f6f9fd;
        .header {
          margin-top: 5%;
          text-align: center;
          font-size: 20px;
          img {
            width: 200px;
          }
        }
        .content {
          margin-top: 1%;
          position: relative;
          .set {
            cursor: pointer;
            position: absolute;
            left: 10px;
            color: #b0b9ca;
            line-height: 15px;
            font-size: 12px;
            border-bottom: 1px solid #b0b9ca;
          }
          .reset {
            cursor: pointer;
            position: absolute;
            right: 10px;
            color: #b0b9ca;
            line-height: 15px;
            font-size: 12px;
            border-bottom: 1px solid #b0b9ca;
          }
          .sms-login {
            cursor: pointer;
            left: 10px;
            color: #0d67c0;
            line-height: 15px;
            font-size: 12px;
            border-bottom: 1px solid #b0b9ca;
            margin-top: 5px;
          }
        }
        .footer {
          padding: 5% 0;
          .login {
            cursor: pointer;
            border-radius: 5px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }
  }
  .content-footer {
    flex: 0 0 auto;
    margin-top: 16px;
    text-align: center;
    width: 100%;
    color: #fff;
    line-height: 1.2;
  }
  .login-build-version {
    position: fixed;
    right: 16px;
    bottom: 12px;
    z-index: 50;
    padding: 4px 8px;
    color: rgba(255, 255, 255, 0.82);
    font-size: 12px;
    line-height: 1.2;
    background: rgba(15, 23, 42, 0.22);
    border: 1px solid rgba(255, 255, 255, 0.28);
    border-radius: 4px;
    text-shadow: 0 1px 2px rgba(15, 23, 42, 0.28);
    pointer-events: none;
    user-select: none;
  }
  .input-box {
    font-size: 20px;
    margin-top: 2%;
    position: relative;
    line-height: 40px;
    color: #677897;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

// 小屏幕适配（平板和小尺寸笔记本）
@media screen and (max-width: 1200px) {
  .pc-login {
    .pc-login_container {
      .title {
        font-size: 40px;
        margin-bottom: 30px;
      }
      .train-list {
        width: 90%;
        max-width: 450px;
        margin-right: 5%;
        top: -40px;
        .training-item h3 {
          font-size: 16px;
        }
      }
      .login-box {
        width: 90%;
        max-width: 380px;
        .box-card {
          padding: 15px;
          .header img {
            width: 150px;
          }
        }
      }
    }
  }
}

// 超小屏幕适配（小平板和大手机横屏）
@media screen and (max-width: 900px) {
  .pc-login {
    .pc-login_container {
      .title {
        font-size: 28px;
        margin-bottom: 20px;
        padding: 10px 20px;
      }
      .train-list {
        display: none; // 隐藏培训列表以节省空间
      }
      .login-box {
        width: 95%;
        max-width: 400px;
        margin: 0 auto;
        .box-card {
          padding: 15px;
          .header {
            font-size: 16px;
            img {
              width: 120px;
            }
          }
          .content .sms-login {
            font-size: 13px;
          }
        }
      }
    }
    .content-footer {
      padding: 10px 0;
      font-size: 12px;
    }
  }
}

@media screen and (max-height: 820px) {
  .pc-login {
    justify-content: center;
    .pc-login_container {
      justify-content: center;
      .title {
        font-size: 46px;
        margin: 0 0 24px;
      }
      .login-box {
        .box-card {
          padding: 16px;
          .header {
            margin-top: 0;
            img {
              width: 150px;
            }
          }
          .footer {
            padding: 16px 0 8px;
          }
        }
      }
    }
  }
}

@media screen and (max-height: 700px) {
  .pc-login {
    padding-top: 12px;
    .pc-login_container {
      .title {
        font-size: 36px;
        margin: 6px 0 14px;
      }
      .login-box {
        .box-card {
          padding: 12px 16px;
          .header img {
            width: 120px;
          }
          .footer {
            padding: 10px 0 4px;
          }
        }
      }
    }
    .content-footer {
      margin-top: 10px;
    }
  }
}

// 手机竖屏适配
@media screen and (max-width: 600px) {
  .pc-login {
    .pc-login_container {
      .title {
        font-size: 22px;
        margin-bottom: 15px;
      }
      .login-box {
        width: 100%;
        padding: 0 15px;
        .box-card {
          padding: 15px 10px;
          .header {
            margin-top: 2%;
            font-size: 14px;
            img {
              width: 100px;
            }
          }
        }
      }
    }
  }
}


// PC 登录页微调：仅统一字体、文字大小和输入框圆角。
.pc-login {
  font-family: "Microsoft YaHei", "PingFang SC", "Noto Sans SC", Arial, sans-serif;

  .pc-login_container {
    .title {
      font-size: 60px;
    }

    .login-box .box-card {
      .el-form-item__label {
        font-size: 15px;
      }

      .el-input__wrapper {
        border-radius: 8px;
      }

      .el-input__inner {
        font-size: 15px;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .pc-login .pc-login_container .title {
    font-size: 42px;
  }
}

.dialag-title {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  color: #677897;
}

.confirm {
  margin-top: 5%;
  cursor: pointer;
  border-radius: 5px;
  text-align: center;
  line-height: 40px;
  color: #fff;
}

// 覆盖element样式
.el-dialog {
  border-radius: 5px !important;
}
.el-dialog__header {
  background-color: #f6f9fd;
  border-radius: 5px !important;
}
.el-dialog__body {
  padding: 0 20px 30px 20px !important;
  background-color: #f6f9fd;
  border-radius: 5px !important;
}
.el-dialog__title {
  color: #677897 !important;
}
.el-form--label-top .el-form-item__label {
  color: #677897;
  padding: 0;
}
.el-form-item {
  margin-bottom: 10px;
}
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  display: none;
}
</style>
